// AppLayoutWithSocket.jsx
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { SocketProvider } from "../contexts/SocketContext";
import { useSelector } from 'react-redux';
import Sidebar from "./Sidebar";

const AppLayoutWithSocket = () => {
    const userInfo = useSelector((state) => state.auth?.user);
    const location = useLocation();

    // User info is now fetched in RequireAuth component, no need to duplicate here

    const hideSidebar = location.pathname.startsWith('/chat');

    return (
        <SocketProvider>
            <div className="app-wrapper">
                {!hideSidebar && <Sidebar />}
                <main className="app-body-wrapper">
                    <Outlet />
                </main>
            </div>
        </SocketProvider>
    );
};

export default AppLayoutWithSocket;
